import { Text, VStack } from '@chakra-ui/react'
import { Body, Input, ValidatedInput } from '@missionlabs/react'
import { useTranslation } from 'react-i18next'

type Props = {
    showMailbox?: boolean
    extension: string
    voicemailPinName: string
    voicemailPinSet: boolean
}

export const Voicemail = ({
    extension,
    voicemailPinName,
    voicemailPinSet,
    showMailbox = false
}: Props) => {
    const { t } = useTranslation()

    return (
        <VStack align="flex-start" spacing={6}>
            <VStack align="flex-start">
                <Body>{t('admin.teams.voicemailPin')}</Body>
                <ValidatedInput name={voicemailPinName}>
                    <Input
                        placeholder={
                            voicemailPinSet ? 'Change your voicemail PIN' : 'Set your voicemail PIN'
                        }
                    />
                </ValidatedInput>
            </VStack>
            {showMailbox && (
                <Text>
                    {t('admin.teams.voicemailId')}: {extension}
                </Text>
            )}
        </VStack>
    )
}
